/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLocalStorage } from '@ds/react-utils'
import { OliveDocuSignTheme } from '../docusign-themes/olive'
import { useTheme } from './useTheme'
import version from '../../version'

export const useDsUiDataProps = (
  component: React.ComponentType<any>,
  legacy?: string,
  restProps: { [x: string]: any } = {},
) => {
  const { name } = useTheme()
  const themeName = name || OliveDocuSignTheme.name

  const [valueOfDsUiTracker] = useLocalStorage<string>('dsUiTracker', 'false')

  const addDsUiDataProps = valueOfDsUiTracker === 'true'

  if (addDsUiDataProps !== true) {
    return undefined
  }

  const additionalDetails =
    legacy === undefined
      ? Object.values(restProps).reduce((acc, val) => {
          return `${acc}-${val}`
        }, '')
      : ''

  // Add legacy details
  let legacyDetails = ''

  if (legacy === 'Olive-specific-prop') {
    legacyDetails = Object.keys(restProps).reduce((acc, propName) => {
      return restProps[propName] !== undefined ? `${acc}-${propName}` : acc
    }, '')
  } else if (legacy === 'Olive-specific-prop-value') {
    legacyDetails = Object.keys(restProps).reduce((acc, propName) => {
      return `${acc}-${propName}-${restProps[propName]}`
    }, '')
  }

  const addLegacyProps =
    legacy === 'Olive-specific' ||
    (legacy === 'Olive-specific-prop' && legacyDetails !== '') ||
    (legacy === 'Olive-specific-prop-value' && legacyDetails !== '')

  const dsUiDataProps = {
    'data-dsui': `${component?.displayName}${additionalDetails}`,
    'data-dsui-theme': themeName,
    'data-dsui-version': version,
    'data-dsui-legacy': addLegacyProps
      ? `${legacy}${legacyDetails}`
      : undefined,
  }
  return dsUiDataProps
}
